import React from 'react';
import User from '../../../data/models/User';
import ActionButton from '../../ui-elements/ActionButton';
import InputField from '../../ui-elements/InputField';

class AccountInfo extends React.Component {
  constructor(props) {
    super(props);

    const users = User.findAll();
    if (users.length > 0) {
      const user = users[0];
      this.state = {
        user: user,
        originalName: user.fullName
      };
    }

    this.updateValues = this.updateValues.bind(this);
    this.submitUpdateInformation = this.submitUpdateInformation.bind(this);
  }

  componentWillUnmount() {
    const { user } = this.state;
    user.fullName = this.state.originalName;
  }

  updateValues(event) {
    const { user } = this.state;
    const stateKey = event.target.getAttribute('statekey');
    user[stateKey] = event.target.value;

    this.setState({
      user: user
    });
  }

  submitUpdateInformation() {
    const { user } = this.state;
    this.setState({
      originalName: user.fullName
    });

    this.state.user.save();
  }

  onSubmit(event) {
    event.preventDefault();
  }

  render() {
    return (
      <div className="card card-body bg-white border-light shadow-sm mb-4">
        <h2 className="h5 mb-4">Account information</h2>
        <form onSubmit={this.onSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <InputField label="Full Name" value={this.state.user.fullName} statekey="fullName" onChange={this.updateValues} />
            </div>
            <div className="col-md-6 mb-3">
              <InputField label="E-Mail Address" value={this.state.user.emailAddress} readOnly={true} />
            </div>
          </div>
          <ActionButton onClick={this.submitUpdateInformation} text="Update information" />
        </form>
      </div>
    );
  }
}

export default AccountInfo;
